export enum AlgoFeatureFlags {
    TurnOffNovaJobSuggestions = 'TURN_OFF_NOVA_JOB_SUGGESTIONS',
    EnableClinicalReviewRefactor = 'enable-clinical-review-refactor',
    RecommendJobsToCandidatesOnRecruitersJobDetailsPage = 'recommend-jobs-to-candidates-on-recruiters-job-details-page',
    RecommendedJobsEventLogging = 'recommended-jobs-events-logging',
    EnableLazyLoadingJobDetailsPage = 'enable-lazy-loading-job-details-page',
    EnableRecruiterQualifiedCandidatesAdditionalColumns = 'enable-recruiter-qualified-candidates-additional-columns',
    EnableSortQualifiedCandidatesOnRecruitersJobDetailsPage = 'sort-qualified-candidates-on-recruiters-job-details-page',
    EnableShowQualifiedCandidatesToRecruitersJobDetailsPage = 'show-qualified-candidates-to-recruiters-job-details-page'
}
